import Honeybadger from "@honeybadger-io/js";

const meta = (name) => document.querySelector(`meta[name="${name}"]`)?.content;

export const shouldIgnoreNotice = (notice) => {
  if (!notice) return false;

  // third-party noise: Intercom's messenger reads its own iframe after
  // Turbolinks detaches it — not actionable in our code
  if (notice.stack && notice.stack.indexOf("js.intercomcdn.com") !== -1) {
    return true;
  }

  if (notice.stack && notice.stack.indexOf("gstatic.com/recaptcha") !== -1) {
    return true;
  }

  // third-party noise: Outlook/Office SafeLink crawlers inject a ClientObject
  // bridge that rejects with this message while scanning our links — not our code
  if (
    notice.message &&
    notice.message.indexOf("Object Not Found Matching Id:") !== -1
  ) {
    return true;
  }

  if (
    notice.message &&
    notice.message.indexOf("Image rejected by content policy") !== -1
  ) {
    return true;
  }

  // Chrome reports this via window.onerror when ResizeObserver cannot deliver
  // every notification in a single frame. Remaining notifications are deferred
  // to the next frame; the spec authors consider it benign.
  if (
    notice.message &&
    (notice.message.indexOf(
      "ResizeObserver loop completed with undelivered notifications"
    ) !== -1 ||
      notice.message.indexOf("ResizeObserver loop limit exceeded") !== -1)
  ) {
    return true;
  }

  return false;
};

const apiKey = meta("honeybadger-api-key");

if (apiKey) {
  Honeybadger.configure({
    apiKey: apiKey,
    environment: meta("honeybadger-environment"),
    maxErrors: 20,
    breadcrumbsEnabled: false,
  });

  Honeybadger.beforeNotify((notice) => {
    if (shouldIgnoreNotice(notice)) {
      return false;
    }
  });

  // Turbolinks merges <head> on navigation without re-running this module,
  // so re-read the user metas on every visit to keep context current
  const syncUserContext = () => {
    const userId = meta("honeybadger-user-id");
    Honeybadger.setContext({
      user_id: userId ? parseInt(userId, 10) : null,
      user_email: meta("honeybadger-user-email") || null,
    });
  };

  syncUserContext();
  document.addEventListener("turbolinks:load", syncUserContext);

  window.Honeybadger = Honeybadger;
}

export default Honeybadger;
